<div class="form" [formGroup]="form">
  <div class="form__col">
    <app-search-select
      [formControl]="searchControl"
      [isLoading]="(isLoadingHints$ | async) === true"
      [hints]="hints$ | async"
      (searchValue)="onSearchAddress($event)"
      (selectHint)="onSelectAddress($event)"
    >
      <div class="select-message message h3" i18n="@@SelectSearchHint">
        Start typing to get a hint (minimum 4 characters)
      </div>
    </app-search-select>

    <div class="message message--error small" *ngIf="isError">
      <span i18n="@@MustContain">Must contain</span>
      <span *ngIf="selectedHint && !selectedHint.city" i18n="@@City">City</span>
      <span *ngIf="selectedHint && !selectedHint.house" i18n="@@House">House</span>
    </div>
  </div>

  <ng-container *ngIf="isFullView">
    <div class="form__col _sm">
      <app-ez-input>
        <input appEzInput
               type="text"
               formControlName="porch"
               name="porch"
               data-testid="porch"
        >
        <ng-container ezLabel i18n="@@Porch">Porch</ng-container>
      </app-ez-input>
    </div>

    <div class="form__col _sm">
      <app-ez-input>
        <input appEzInput
               type="text"
               formControlName="flat"
               name="flat"
               data-testid="flat"
        >
        <ng-container ezLabel i18n="@@Flat">Flat</ng-container>
      </app-ez-input>
    </div>

    <div class="form__col _sm">
      <app-ez-input>
        <input appEzInput
               type="text"
               formControlName="floor"
               name="floor"
               data-testid="floor"
        >
        <ng-container ezLabel i18n="@@Floor">Floor</ng-container>
      </app-ez-input>
    </div>
  </ng-container>
</div>
